module.exports = __webpack_public_path__ + "static/media/3-9.95707539.mp3";